import { render, staticRenderFns } from "./AllEvents.vue?vue&type=template&id=3795362d"
import script from "./AllEvents.vue?vue&type=script&lang=js"
export * from "./AllEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports